
export const categories = [
    'home', 'skills', 'experience', 'projects', 'research', 'contact'
]